import { Lock } from '../Icons';
import { Brand } from '../Brand';

export default function SafePlace() {
  return (
    <section id="trust" className="section container">
      <div className="safeplace__inner">
        <div>
          <span className="eyebrow eyebrow--indigo">A safe place to ask</span>
          <h2 className="safeplace__title">
            Think out loud about a difficult situation, without risk.
          </h2>
          <p className="safeplace__text">
            Under GDPR, employees have the right to access data about themselves, including email, Teams or ChatGPT messages that you've written. <Brand /> conversations are encrypted and expire by
            default, so by design there's nothing to disclose, and you decide what's worth
            keeping.
          </p>
        </div>
        <div className="safeplace__chat">
          <div className="chat-bubble chat-bubble--in">
            Can I put a 12-month non-compete on this contract?
          </div>
          <div className="chat-bubble chat-bubble--out">
            In the UK a court will only enforce what's reasonable to protect the business, and 12
            months is likely too long for this role. Here's a safer term to use instead.
          </div>
          <div className="safeplace__expire">
            <Lock />
            This conversation expires automatically
          </div>
        </div>
      </div>
    </section>
  );
}
